import React, {useEffect, useState} from "react";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";
import {Box, Button, MenuItem, TextField, Typography, Snackbar, Paper} from '@material-ui/core';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import axiosInstance from "../../api";
import {Alert} from "@material-ui/lab";
import Spinner from "../../components/Spinner";
import CCUserAgentDashboard from "../agents/CCUserAgentDashboard"
import PageviewIcon from '@mui/icons-material/Pageview';
import {ArrowUpward, ArrowDownward} from '@mui/icons-material';
import {useUserContext} from "../../context/UserContext";


export default function LeadsTaggedAgentListView({lead, onActionClick}) {
    const [agentsListdata, setAgentsListData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [pageToShow, setPageToShow] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfRecordsPerPage, setNumberOfRecordsPerPage] = useState(60);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [userRoleList, setUserRoleList] = useState([]);
    const [openSnackBarError, setOpenSnackBarError] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState(null);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [state, setState] = useState({
        leadId: "",
    });
    const [order, setOrder] = useState(false);

    const [agentId,setAgentId] = useState();
    const [isAgentClicked,setIsAgentClicked] = useState(false);
    const {user,dispatch} = useUserContext();
    const [sortedField, setSortedField] = useState(null);

    useEffect(() => {
        if(agentsListdata.length === 0){
            const searchCiteria = {
                leadId: lead && lead.leadId ? lead.leadId : "",
                numberOfRecordsPerPage: numberOfRecordsPerPage,
                pageToShow: currentPage,
                includeSortBy: true,
                sortBy: "status",
                descending: order,

            }
            getAgentsList(searchCiteria, false);
        }
    }, []);

    const getAgentsList = (searchCiteria, sortClicked) => {
        setShowSpinner(true);
        axiosInstance.post(`search/get-referral-agent-info`, searchCiteria)
            .then(data => {
                let previousArray = []
                if(!sortClicked){
                previousArray = [...agentsListdata]
                }
                let agentsData = []
                agentsData = previousArray.concat(data.resultList);
                //const agentsData = data.resultList;
                setAgentsListData(agentsData);
                setShowTable(true)
                setShowSpinner(false);
            })
            .catch(err =>{
            }).finally(() => setShowSpinner(false))
    }

    const handleChangePage = (event, newPage) => {
        const currentPageNumber = (agentsListdata.length/rowsPerPage) - 1;
        if(currentPageNumber === newPage){
            const newPageNumber = currentPage + 1;
            setShowTable(false)
            setShowSpinner(true);
            setCurrentPage(newPageNumber);
            const searchCiteria = {
                leadId: lead && lead.leadId ? lead.leadId : "",
                numberOfRecordsPerPage: numberOfRecordsPerPage,
                pageToShow: newPageNumber,
                includeSortBy: true,
                sortBy: "status",
                descending: order,
            }
            getAgentsList(searchCiteria, false);
        }
        setPageToShow(newPage);
    };

    const handleSnackBarClose = (event, reason) => {
        setOpenSnackBar(false);
        setOpenSnackBarError(false);
    };

    const agentInformation = (row) => e => {
        setAgentId(row.agentId);
        setIsAgentClicked(true);
        onActionClick(true);
    }

    const onReturnBack = () => {
        setIsAgentClicked(false);
        onActionClick(false);
    }

    const handleSort = (name) => e => {
        setAgentsListData([]);
        if(order){
            const searchCiteria = {
                leadId: lead && lead.leadId ? lead.leadId : "",
                numberOfRecordsPerPage: numberOfRecordsPerPage,
                pageToShow: currentPage,
                includeSortBy: true,
                sortBy: "status",
                descending: false,
    
            }
            getAgentsList(searchCiteria, true);
            setOrder(false);
        }else{
            const searchCiteria = {
                leadId:  lead && lead.leadId ? lead.leadId : "",
                numberOfRecordsPerPage: numberOfRecordsPerPage,
                pageToShow: currentPage,
                includeSortBy: true,
                sortBy: "status",
                descending: true,
    
            }
            getAgentsList(searchCiteria, true);
            setOrder(true);
        }
    }

    if (showSpinner) return <Spinner/>
    return (
        <React.Fragment>
            {(!isAgentClicked) &&
            <Paper style={{border:"1px solid #fff"}}>
                <Box m={3}>
                <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleSnackBarClose}>
                    <Alert variant="filled" onClose={handleSnackBarClose} severity="success">{snackBarMessage}</Alert>
                </Snackbar>
                <Snackbar open={openSnackBarError} autoHideDuration={6000} onClose={handleSnackBarClose}>
                    <Alert variant="filled" onClose={handleSnackBarClose} severity="error">{snackBarMessage}</Alert>
                </Snackbar>
                <Grid container style={{marginTop:"-0.5rem"}}>
                    <TableContainer>
                        <Table size="small" aria-label="a dense table" >
                            <TableHead style={{backgroundColor: "#1c2438"}}>
                                <TableRow >
                                    <TableCell style={{color: "#ffffff"}}>Agent Name</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>DFS</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>ADDRESS</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Email</TableCell>
    
                                    <TableCell style={{color: "#ffffff", cursor:"pointer"}} onClick={handleSort("status")}>
                                    <div style={{display:"flex", alignItems:"center"}}>
                                        Status
                                        {order ? 
                                        <div style={{display:"flex", alignItems:"center", justifyContent: "center"}}>
                                            <ArrowDownward style={{ height:"1.15rem"}}/> 
                                        </div>: 
                                        <div style={{display:"flex", alignItems:"center", justifyContent: "center"}}>
                                            <ArrowUpward style={{ height:"1.15rem"}}/>
                                        </div> }
                                    </div>
                                    </TableCell>
    
                                    <TableCell style={{color: "#ffffff"}}>PHONE</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {agentsListdata.slice(pageToShow * rowsPerPage, pageToShow * rowsPerPage + rowsPerPage).map((row, i) => (
                                    <TableRow
                                        key={i}
                                    >
                                        <TableCell>
                                            {`${row.agentFName} ${row.agentLName}`}
                                        </TableCell>
                                        <TableCell>
                                            {row.dfsLicense}
                                        </TableCell>
                                        <TableCell>{row.addressLine1} {row.addressLine2},{row.city},{row.state},{row.zip1}</TableCell>
                                        <TableCell>{row.agentEmail}</TableCell>
                                        <TableCell>{row.quoteStatusLabel}</TableCell>
                                        <TableCell>{row.agentPhoneNumber}</TableCell>
                                        <TableCell>
                                        <div style={{display:"flex", alignItems:"center", justifyContent: "flex-start"}}>
                                        {<PageviewIcon titleAccess={"Agent Dashboard Information"} onClick={agentInformation(row)}  style={{cursor:"pointer"}}/>}
                                        </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Grid container alignItems="center" justifyContent="flex-end" columns={20} m={0} style={{background:"#fff"}}>
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={agentsListdata.length}
                            rowsPerPage={rowsPerPage}
                            page={pageToShow}
                            onPageChange={handleChangePage}
                            //onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Grid>
                </Grid>
                </Box>
            </Paper>
            }
              {isAgentClicked  && <Box m={2}>
                <CCUserAgentDashboard agentId={agentId} onReturnBack={onReturnBack}/>
            </Box>}
        </React.Fragment>
    );
}

